// アプリケーション名
const ApplicationNames = {
  DODA_SITE_SPA: 'dodaSiteSpa',
};

// 設定名
const ConfigurationNames = {
  MICROSERVICE: 'microservice',
};

// Featureフラグ名
const FlagNames = {
  FEATURED_JOB: 'featuredjob',
  JOB_SEARCH_LIST_PC: 'jobsearchlistpc',
  JOB_SEARCH_LIST_SP: 'jobsearchlistsp',
  JOB_SEARCH_DETAIL_PC: 'jobsearchdetailpc',
  JOB_SEARCH_DETAIL_SP: 'jobsearchdetailsp',
  NEAR_AREA_PC: 'nearareapc',
  NEAR_AREA_SP: 'nearareasp',
};

// Featureフラグ定義
export const FeatureFlagSettings = {
  // 特集求人
  FEATURED_JOB: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.FEATURED_JOB,
  },
  // 求人一覧検索 (PC)
  JOB_SEARCH_LIST_PC: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.JOB_SEARCH_LIST_PC,
  },
  // 求人一覧検索 (SP)
  JOB_SEARCH_LIST_SP: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.JOB_SEARCH_LIST_SP,
  },
  // 求人詳細 (PC)
  JOB_SEARCH_DETAIL_PC: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.JOB_SEARCH_DETAIL_PC,
  },
  // 求人詳細 (SP)
  JOB_SEARCH_DETAIL_SP: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.JOB_SEARCH_DETAIL_SP,
  },
  // 近隣エリア (PC)
  NEAR_AREA_PC: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.NEAR_AREA_PC,
  },
  // 近隣エリア (SP)
  NEAR_AREA_SP: {
    applicationName: ApplicationNames.DODA_SITE_SPA,
    configurationName: ConfigurationNames.MICROSERVICE,
    flagName: FlagNames.NEAR_AREA_SP,
  },
};
